import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { InspectorObra } from '../../../models/inspector_obra.model';
import {Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-inspector_obra",
    templateUrl: "./inspector_obra.component.html",
    providers: [UserService, FormService]
})

export class InspectorObraComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;
    
    public rut_insp;
    public invalidRut: Boolean;
    public inspector_obra: InspectorObra;
    public rows = [];
    public actualRow;
    public matcher = new FormService();

    public filteredOptions;
    public nombreComuna = new FormControl('', [ Validators.required]);
    options = []
    public selectedIns:number = null;


   constructor(private fb: FormBuilder, private _userService: UserService,
     rutValidator: RutValidator, public dialog: MatDialog, private spinner: NgxSpinnerService){
        this.rut_insp = this.fb.group({
        rut: ['', [Validators.required, rutValidator]]
        })
        
        if(!JSON.parse(localStorage.getItem("inspectorObra"))){
            localStorage.setItem("inspectorObra", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("inspectorObra"));
            console.log(this.rows)
        }
        this.invalidRut = true;
            this.inspector_obra = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
    }

    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }

      private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
    
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
      }

    get_inspector_obra(rut){
        this.spinner.show();
        this.cleanData();
        this._userService.getinspector_obra(rut).subscribe(
            response => {
                if(response.message){
                    this.inspector_obra.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal)
                } else {
                    this.inspector_obra.rut = response.rut ? response.rut : '';
                    this.inspector_obra.nombre = response.nombre ? response.nombre : '';
                    this.inspector_obra.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.inspector_obra.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.inspector_obra.direccion = response.direccion ? response.direccion : '';
                    this.inspector_obra.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.inspector_obra.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.inspector_obra.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.inspector_obra.comuna = response.comuna ? response.comuna : '';
                    this.inspector_obra.fono = response.fono ? response.fono : '';
                    this.inspector_obra.mail = response.mail ? response.mail : '';
                    this.inspector_obra.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal)
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }

    cleanData(){
        this.inspector_obra = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
            this.rut_insp.reset()
    }

   
    update_inspector_obra(rut, id) {
        this.get_inspector_obra(rut);
        this.selectedIns = id;
    }


    saveinspector_obra() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.inspector_obra.rut == this.rows[x].rut) {                
                this.delete_inspector_obra(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedIns != null) {
            this.delete_inspector_obra(this.selectedIns);
            this.selectedIns = null;
        }*/

        this.spinner.show();
        this._userService.saveinspector_obra(this.inspector_obra).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#rep_modal").modal("hide");
                    this.actualRow = localStorage.getItem("inspectorObra");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.inspector_obra.rut,
                        nombre: this.inspector_obra.nombre,
                        apellido_pat: this.inspector_obra.apellido_pat,
                        apellido_mat: this.inspector_obra.apellido_mat,
                        direccion:this.inspector_obra.direccion, 
                        direccion_num:this.inspector_obra.direccion_num, 
                        direccion_complemento:this.inspector_obra.direccion_complemento, 
                        direccion_completa:this.inspector_obra.direccion_completa, 
                        comuna:this.inspector_obra.comuna, 
                        fono:this.inspector_obra.fono,
                        mail:this.inspector_obra.mail
                    })
                    localStorage.setItem("inspectorObra", JSON.stringify(this.rows));
                    this.inspector_obra = {rut:'', nombre:'',  apellido_mat:'', apellido_pat:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', mail:'', recordId:''};
                    this.rut_insp.reset()
                    this.dialog.closeAll();
                     
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_inspector_obra(id) {

        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("inspectorObra", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('inspectorObra'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}